<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="subset_name">
                                                {{ $t('money_request.followup_code') + ' (' + $t('money_request.tracking_code') + ')' }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="tracking_number"
                                                name="tracking_number"
                                                id="tracking_number"
                                                v-model="query.tracking_number"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="price">
                                                {{ $t('label.price') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="amount"
                                                name="amount"
                                                id="amount"
                                                v-model="query.amount"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="bill_id">
                                                {{ $t('money_request.bill_id') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="bill_id"
                                                name="bill_id"
                                                id="bill_id"
                                                v-model="query.bill_id"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="pay_id">
                                                {{ $t('money_request.pay_id') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="pay_id"
                                                name="pay_id"
                                                id="pay_id"
                                                v-model="query.pay_id"/>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="from_date"
                                                name= "from_date"
                                                v-model="query.from_date"
                                                type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="to_date"
                                                name= "to_date"
                                                v-model="query.to_date"
                                                type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('money_request.payment_method') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="payment_method"
                                                    class="form-control"
                                                    name="payment_method"
                                                    v-model="query.payment_method"
                                            >
                                                <option
                                                   value=""
                                                >
                                                    {{ $t('selectpicker.nothing_selected')}}
                                                </option>
                                                <option
                                                   :value="payment_methods[2].value"
                                                >
                                                    {{ payment_methods[2].name}}
                                                </option>
                                                <option
                                                   :value="payment_methods[1].value"
                                                >
                                                    {{ payment_methods[1].name}}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="3">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('money_request.status') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="status"
                                                    class="form-control"
                                                    name="status"
                                                    v-model="query.status"
                                            >
                                                <option
                                                        v-bind:key="index"
                                                        v-for="(status, index) in statuses"
                                                        v-bind:value="status.value"
                                                        :selected="query.status === status.value"
                                                >
                                                    {{ status.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import { i18n } from '@/plugins/i18n'
import {moneyRequestPaymentStatus} from '@/constants/moneyRequestPaymentStatus'

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true
        }
    },
    data() {
        return {
            query: {},
            moneyRequestPaymentStatus: moneyRequestPaymentStatus,
            statuses: [
                {
                    name: '',
                    value: ''
                },
                {
                    name: i18n.t('money_request.pending'),
                    value: 'zero'
                },
                {
                    name: i18n.t('money_request.succeed_payment'),
                    value: moneyRequestPaymentStatus.SUCCESS
                },
            ],
            payment_methods:[
                {
                    value:'',
                    name:i18n.t('selectpicker.nothing_selected'),
                },
                {
                    value:1,
                    name:i18n.t('money_request.ipg_method'),
                },
                {
                    value:0,
                    name:i18n.t('money_request.payment_with_id'),
                } ,
                {
                    value:2,
                    name:i18n.t('label.ipg_bill'),
                }
            ]
        }
    },
    methods: {
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
    },
}

</script>
